import { useMemo } from 'react'
import { AccountType } from '@/common/types'
import { useFetchAccountParticipants } from '@/account/accountQueries'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { buildAccountHolderDetailItems } from './accountHolderDetails'
import type { DetailItem } from '../types'

export function useAccountHolderItems(): DetailItem[][] {
    const account = useCurrentAccount()

    const { data: participantsResponse } = useFetchAccountParticipants(account?.accountId ?? '', {
        enabled: Boolean(account?.accountId) && account?.accountType !== AccountType.ADVISER,
    })

    const participants = (participantsResponse?.participants ?? []).filter((p) => p.role !== 'PARTICIPANT')

    const accountHolders = useMemo(() => {
        return participants?.map(buildAccountHolderDetailItems) ?? []
    }, [participants])

    return accountHolders
}
